import "core-js/modules/web.dom-collections.iterator.js";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/pc/icons/icon-apple.png';
import _imports_1 from '@/assets/images/pc/icons/icon-android.png';
import _imports_2 from '@/assets/images/pc/home-logo2.png';
const _withScopeId = n => (_pushScopeId("data-v-37f541e9"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "promotion-pc"
};
const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("i", {
  class: "ico-qrcode"
}, null, -1));
const _hoisted_3 = {
  key: 0
};
const _hoisted_4 = {
  class: "qr-section"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "bottom"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "12",
  height: "14"
}), /*#__PURE__*/_createElementVNode("span", null, "|"), /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "14",
  height: "14"
})], -1));
const _hoisted_6 = {
  key: 0,
  class: "ico-home"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "right-section"
}, [/*#__PURE__*/_createElementVNode("img", {
  src: _imports_2
}), /*#__PURE__*/_createElementVNode("span", {
  class: "button"
})], -1));
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "arrow"
}, [/*#__PURE__*/_createElementVNode("i", {
  class: "ico-arrow-right"
})], -1));
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Qrcode = _resolveComponent("Qrcode");
  const _component_image_cdn = _resolveComponent("image-cdn");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    id: "download-btn",
    class: _normalizeClass({
      'large': $setup.state.downloadBtnLarge,
      'downbtn-fifa': $setup.store.state.common.showFifaFlag
    })
  }, [_hoisted_2, $setup.state.downloadBtnLarge ? (_openBlock(), _createElementBlock("p", _hoisted_3, "下载尊龙凯时APP")) : _createCommentVNode("", true), _createElementVNode("div", {
    id: "site-download",
    class: _normalizeClass(["", {
      'show': $setup.showSiteDownload
    }])
  }, [_createElementVNode("div", _hoisted_4, [$setup.state.appDownloadUrl ? (_openBlock(), _createBlock(_component_Qrcode, {
    key: 0,
    id: "site-qrcode-image",
    url: $setup.state.appDownloadUrl,
    imgSize: 120
  }, null, 8, ["url"])) : _createCommentVNode("", true)]), _hoisted_5], 2)], 2), _createElementVNode("div", {
    id: "home-btn",
    class: _normalizeClass({
      'large': $setup.state.downloadBtnLarge,
      'homebtn-fifa': $setup.store.state.common.showFifaFlag
    }),
    onMouseover: _cache[1] || (_cache[1] = $event => $setup.showHome()),
    onClick: _cache[2] || (_cache[2] = (...args) => $setup.gotoHome && $setup.gotoHome(...args))
  }, [!$setup.state.downloadBtnLarge ? (_openBlock(), _createElementBlock("i", _hoisted_6)) : _createCommentVNode("", true), $setup.state.downloadBtnLarge ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    id: "site-home",
    onMouseleave: _cache[0] || (_cache[0] = $event => $setup.hideHome())
  }, [_createVNode(_component_image_cdn, {
    id: "download-logo-image",
    src: require('@/assets/images/pc/home-logo1.png'),
    alt: ""
  }, null, 8, ["src"]), _hoisted_7], 32)) : _createCommentVNode("", true)], 34), _createElementVNode("div", {
    id: "btn-show-large",
    class: _normalizeClass({
      'large': $setup.state.downloadBtnLarge,
      'showbtn-fifa': $setup.store.state.common.showFifaFlag
    })
  }, [_createElementVNode("div", {
    class: "pointer",
    onClick: _cache[3] || (_cache[3] = $event => $setup.setLargeButton())
  }, [_hoisted_8, _createElementVNode("div", null, _toDisplayString($setup.state.btnShowText), 1)])], 2)]);
}